export default "/images/4e41478f84430c862efd9d600a0201d3.avif";